import { WebTracerProvider } from "@opentelemetry/sdk-trace-web";
import { ZoneContextManager } from "@opentelemetry/context-zone";
import { registerInstrumentations } from "@opentelemetry/instrumentation";
import { DocumentLoadInstrumentation } from "@opentelemetry/instrumentation-document-load";
import { FetchInstrumentation } from "@opentelemetry/instrumentation-fetch";
import { XMLHttpRequestInstrumentation } from "@opentelemetry/instrumentation-xml-http-request";
import { Resource } from "@opentelemetry/resources";
import { SEMRESATTRS_SERVICE_NAME } from "@opentelemetry/semantic-conventions";

export function initTelemetry() {
  try {
    // Initialize for trace context propagation only (no span export)
    const provider = new WebTracerProvider({
      resource: new Resource({
        [SEMRESATTRS_SERVICE_NAME]: "nomato-frontend",
      }),
    });

    provider.register({
      contextManager: new ZoneContextManager(),
    });

    registerInstrumentations({
      instrumentations: [
        new DocumentLoadInstrumentation(),
        new FetchInstrumentation({
          ignoreUrls: [
            /api\.mapbox\.com/,
            /tiles\.mapbox\.com/,
            /events\.mapbox\.com/,
            /firebaseapp\.com/,
            /googleapis\.com/,
            /fonts\.googleapis\.com/,
            /fonts\.gstatic\.com/,
          ],
          propagateTraceHeaderCorsUrls: /\/api/,
          clearTimingResources: true,
        }),
        new XMLHttpRequestInstrumentation({
          ignoreUrls: [
            /api\.mapbox\.com/,
            /tiles\.mapbox\.com/,
            /events\.mapbox\.com/,
            /firebaseapp\.com/,
            /googleapis\.com/,
          ],
          propagateTraceHeaderCorsUrls: /\/api/,
        }),
      ],
    });

    console.log("📊 OpenTelemetry initialized (context propagation only)");
  } catch (error) {
    console.warn("OpenTelemetry initialization failed:", error);
  }
}
